export const warehouse = {
  title: 'Raktárkezelés',
  subtitle: 'Raktárak és raktárhelyek kezelése',
  
  tab: {
    warehouses: 'Raktárak',
    locations: 'Raktárhelyek'
  },
  
  list: {
    title: 'Raktárak',
    empty: 'Nincs még létrehozott raktár',
    search: 'Raktár keresése',
    create: 'Új raktár létrehozása',
    edit: 'Raktár szerkesztése',
    delete: 'Raktár törlése',
    deleteConfirmation: 'Biztosan törölni szeretné ezt a raktárat?'
  },
  
  fields: {
    name: 'Raktár neve',
    code: 'Raktárkód',
    location: 'Cím',
    description: 'Megjegyzés',
    isActive: 'Aktív',
    isDefault: 'Alapértelmezett raktár',
    status: 'Állapot'
  },
  
  create: 'Új raktár',
  edit: 'Raktár szerkesztése',
  default: 'Alapértelmezett',
  hasInventory: 'Tartalmaz készletet',
  
  locations: {
    title: 'Raktárhelyek',
    empty: 'Nincsenek raktárhelyek ebben a raktárban',
    create: 'Új raktárhely',
    edit: 'Raktárhely szerkesztése',
    delete: 'Raktárhely törlése',
    deleteConfirmation: 'Biztosan törölni szeretné ezt a raktárhelyet?',
    comingSoon: 'A raktárhelyek kezelése hamarosan elérhető lesz'
  },
  
  success: {
    created: 'A raktár sikeresen létrehozva',
    updated: 'A raktár sikeresen módosítva',
    deleted: 'A raktár sikeresen törölve'
  },
  
  error: {
    create: 'Hiba történt a raktár létrehozásakor',
    update: 'Hiba történt a raktár módosításakor',
    delete: 'Hiba történt a raktár törlésekor',
    notFound: 'A raktár nem található',
    cannotDeleteWithInventory: 'A raktár nem törölhető, mert tartalmaz készlet rekordokat',
    cannotDeleteWithHistory: 'A raktár nem törölhető, mert tartalmaz készletmozgás történetet'
  }
}; 